import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router-dom";
import * as Ant from "antd";
import { Routes } from "@bundles/UIAppBundle";
import { useUIComponents, useRouter, useDataOne, use, useTranslate, } from "@bluelibs/x-ui";
import { ObjectId } from "@bluelibs/ejson";
import { ReportsCollection } from "@bundles/UIAppBundle/collections";
import { ReportViewer } from "../../config/ReportViewer";
import { features } from "../../config/features";
export function ReportsView(props) {
    const UIComponents = useUIComponents();
    const router = useRouter();
    const t = useTranslate();
    const collection = use(ReportsCollection);
    // If you want to benefit of live data features use useLiveData()
    const { data: document, isLoading, error, } = useDataOne(ReportsCollection, new ObjectId(props.id), ReportViewer.getRequestBody());
    let content;
    if (isLoading) {
        content = (_jsx(Ant.Space, Object.assign({ align: "center" }, { children: _jsx(Ant.Spin, { size: "large" }, void 0) }), void 0));
    }
    else {
        if (error || document === null) {
            content = (_jsx(Ant.Alert, { message: error || t("generics.error_message"), type: "error" }, void 0));
        }
        else {
            content = _jsx(ReportsViewComponent, { document: document }, void 0);
        }
    }
    return (_jsxs(UIComponents.AdminLayout, { children: [_jsx(Ant.PageHeader, { title: t("management.reports.view.header"), onBack: () => window.history.back(), extra: getHeaderActions(collection, router, props.id) }, void 0), _jsxs(Ant.Card, Object.assign({ className: "page-reports-list" }, { children: [content, (document === null || document === void 0 ? void 0 : document.content) && (_jsxs("div", Object.assign({ className: "content" }, { children: [_jsx("p", Object.assign({ className: "title" }, { children: t("management.reports.view.report_content") }), void 0), _jsx("div", Object.assign({ className: "html-content" }, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: document.content } }, void 0) }), void 0)] }), void 0))] }), void 0)] }, void 0));
}
export function ReportsViewComponent(props) {
    const document = props.document;
    const viewer = use(ReportViewer, { transient: true });
    viewer.setDocument(document);
    viewer.build();
    return (_jsx(Ant.Descriptions, { children: viewer.rest().map((item) => {
            return (_jsx(Ant.Descriptions.Item, Object.assign({ label: item.label }, { children: viewer.render(item) }), item.id));
        }) }, void 0));
}
export function getHeaderActions(collection, router, id) {
    const actions = [];
    const t = useTranslate();
    if (features.edit) {
        actions.push(_jsx(Link, Object.assign({ to: router.path(Routes.REPORTS_EDIT, {
                params: { id },
            }) }, { children: _jsx(Ant.Button, { children: t("generics.edit") }, void 0) }), "edit"));
    }
    if (features.delete) {
        actions.push(_jsx(Ant.Popconfirm, Object.assign({ title: "Are you sure you want to delete this Report?", onConfirm: () => {
                collection.deleteOne(id).then(() => {
                    router.go(Routes.REPORTS_LIST);
                    Ant.notification.success({
                        message: "Success",
                        description: "You have deleted the Report",
                    });
                });
            } }, { children: _jsx(Ant.Button, Object.assign({ danger: true }, { children: t("generics.delete") }), void 0) }), "delete"));
    }
    const viewRoutePath = router.path(Routes.REPORTS_VIEW, {
        params: { id },
    });
    return actions;
}
